export const getActiveFiltersCount = (filters = {}) => Object.values(filters)
  .filter(val => typeof val !== 'string' && val).length; // исключаем query из подсчета
